var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7538 0.889342C15.7584 0.945909 16.2518 1.09466 16.7064 1.90336C17.1799 2.71101 17.4188 4.10213 17.4188 6.55232V6.55546V6.5607C17.4188 8.99936 17.1799 10.401 16.7075 11.2002C16.2529 12.0089 15.7595 12.1556 14.7549 12.2237C13.7503 12.2813 11.2268 12.3159 9.04058 12.3159C6.85018 12.3159 4.32562 12.2813 3.32208 12.2226C2.31959 12.1545 1.8262 12.0079 1.36738 11.1992C0.899136 10.3999 0.658203 8.99831 0.658203 6.55965V6.55755V6.55441V6.55127C0.658203 4.10213 0.899136 2.71101 1.36738 1.90336C1.8262 1.09361 2.32064 0.945909 3.32313 0.888294C4.32562 0.821252 6.85018 0.792969 9.04058 0.792969C11.2268 0.792969 13.7503 0.821252 14.7538 0.889342ZM12.1811 6.55441L6.94341 3.41181V9.69702L12.1811 6.55441Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.4e0099be235ccc054808056978079679.svg";
export { ForwardRef as ReactComponent };